import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Paper from '@material-ui/core/Paper'
import { selectTeamTracking } from '@views/tracking/state/trackingSlice2'
import { TrackingRows } from '@types'
import { useSelector } from 'react-redux'

// function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1
//   }
//   return 0
// }

type Order = 'asc' | 'desc'

// function getComparator<Key extends keyof any>(
//   order: Order,
//   orderBy: Key
// ): (a: any, b: any) => number {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy)
// }

// function stableSort(
//   array: TrackingRows[],
//   comparator: (a: TrackingRows, b: TrackingRows) => number
// ) {
//   const stabilizedThis = array.map(
//     (el, index) => [el, index] as [TrackingRows, number]
//   )
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0])
//     if (order !== 0) return order
//     return a[1] - b[1]
//   })
//   return stabilizedThis.map(el => el[0])
// }

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string, isNumeric: boolean) => void
  order: Order
  orderBy: string
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props
  const createSortHandler = (property: string, isNumeric: boolean) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property, isNumeric)
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell align="left" sortDirection={orderBy === 'progress' ? order : false}>
          <TableSortLabel
            active={orderBy === 'name'}
            direction={orderBy === 'name' ? order : 'asc'}
            onClick={createSortHandler('name', false)}
          >
            Ahorrador
          </TableSortLabel>
        </TableCell>
        <TableCell align="left" sortDirection={orderBy === 'progress' ? order : false}>
          <TableSortLabel
            active={orderBy === 'progress'}
            direction={orderBy === 'progress' ? order : 'asc'}
            onClick={createSortHandler('progress', true)}
          >
            Progreso
          </TableSortLabel>
        </TableCell>
        <TableCell align="left" sortDirection={orderBy === 'studyDate' ? order : false}>
          <TableSortLabel
            active={orderBy === 'studyDate'}
            direction={orderBy === 'studyDate' ? order : 'asc'}
            onClick={createSortHandler('studyDate', false)}
          >
            Fecha de estudio
          </TableSortLabel>
        </TableCell>
        <TableCell align="left" sortDirection={orderBy === 'officeOrBank' ? order : false}>
          <TableSortLabel
            active={orderBy === 'officeOrBank'}
            direction={orderBy === 'officeOrBank' ? order : 'asc'}
            onClick={createSortHandler('officeOrBank', false)}
          >
            Completo en oficina / Radicado en banco
          </TableSortLabel>
        </TableCell>
        <TableCell align="left" sortDirection={orderBy === 'success' ? order : false}>
          <TableSortLabel
            active={orderBy === 'success'}
            direction={orderBy === 'success' ? order : 'asc'}
            onClick={createSortHandler('success', false)}
          >
            Exitoso
          </TableSortLabel>
        </TableCell>
        <TableCell align="left" sortDirection={orderBy === 'feesOrPayments' ? order : false}>
          <TableSortLabel
            active={orderBy === 'feesOrPayments'}
            direction={orderBy === 'feesOrPayments' ? order : 'asc'}
            onClick={createSortHandler('feesOrPayments', false)}
          >
            Honorarios / Abonos
          </TableSortLabel>
        </TableCell>
        {/* <TableCell
          align="left"
          sortDirection={orderBy === 'progress' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'progress'}
            direction={orderBy === 'progress' ? order : 'asc'}
            // onClick={createSortHandler('progress', false)}
          >
            Documentos
          </TableSortLabel>
        </TableCell>
        <TableCell
          align="left"
          sortDirection={orderBy === 'progress' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'progress'}
            direction={orderBy === 'progress' ? order : 'asc'}
            onClick={createSortHandler('progress', false)}
          >
            Comentarios
          </TableSortLabel>
        </TableCell> */}
      </TableRow>
    </TableHead>
  )
}

export default function FilterTrack() {
  const [order, setOrder] = React.useState<Order>('asc')
  const [isNumeric, setIsNumeric] = React.useState(false)
  const [orderBy, setOrderBy] = React.useState<string>('name')
  const rows: TrackingRows[] = useSelector(selectTeamTracking)

  const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string, isNumeric: boolean) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
    setIsNumeric(isNumeric)
  }

  return (
    <div className="center_view" style={{ marginTop: '100px' }}>
      <Paper>
        <TableContainer>
          <Table stickyHeader aria-labelledby="tableTitle" size="medium" aria-label="enhanced table">
            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
            <TableBody>
              {rows
                .sort((a: any, b: any) => {
                  if (isNumeric) {
                    if (order === 'asc') return b[orderBy] - a[orderBy]
                    else return a[orderBy] - b[orderBy]
                  } else {
                    if (order === 'asc') return b[orderBy].localeCompare(a[orderBy])
                    else return a[orderBy].localeCompare(b[orderBy])
                  }
                })
                .map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`

                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      <TableCell component="th" id={labelId} scope="row" padding="none">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.progress}</TableCell>
                      <TableCell align="right">{row.studyDate}</TableCell>
                      <TableCell align="right">{row.office}</TableCell>
                      <TableCell align="right">{row.bank}</TableCell>
                      <TableCell align="right">{row.success}</TableCell>
                      <TableCell align="right">{row.feesOrPayments}</TableCell>
                      {/* <TableCell align="right">{row.files}</TableCell>
                      <TableCell align="right">{row.comments}</TableCell> */}
                    </TableRow>
                  )
                })}
              {
                <TableRow style={{ height: 53 }}>
                  <TableCell colSpan={6} />
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  )
}
